import getEsQuery from '../esParser'

async function metrics (payload) {
  const jsonQuery = payload.query

  const esSearch = getEsQuery(jsonQuery, payload)
  esSearch.aggs = getMetricsAggregation()
  const url = `${process.env.ES_URL}/${process.env.LAS_INDEX}/_search`
  const auth = process.env.ES_AUTH
  const headers = { 'Content-Type': 'application/json' }
  if (auth) headers.Authorization = auth

  const results = await fetch(url, {method: 'POST', headers, body: JSON.stringify(esSearch)}).then(r => r.json())
  const aggregations = results.aggregations
  const totalAudience = aggregations.UNIVERSE.value
  if (Number.isFinite(totalAudience) && totalAudience > 0) {
    return {
      data: {
        male: (parseInt(aggregations.no_of_male.value) / totalAudience) * 100,
        female: (parseInt(aggregations.no_of_female.value) / totalAudience) * 100,
        kids: (parseInt(aggregations.no_of_children.value) / totalAudience) * 100,
        house: (parseInt(aggregations.home_owners.value) / totalAudience) * 100,
        income: aggregations.avg_income.value * 1000
      }
    }
  }
  return {data: {male: 0, female: 0, kids: 0, house: 0, income: 0}}
}

function getMetricsAggregation () {
  return {
    METRICS: {
      date_histogram: {field: 'broadcastdate', interval: 'month', format: 'yyyy-MM'},
      aggs: {
        Avg_income: {avg: {field: 'household.householdincome'}},
        Home_owners: {
          filter: {term: {'household.homeownershipstatus': 'Owned'}},
          aggs: {home_owners_count: {sum: {field: 'intabweight'}}},
        },
        No_of_children: {
          filter: {range: {'household.numberofchildren': {gt: 0}}},
          aggs: {children_count: {sum: {field: 'intabweight'}}},
        },
        No_of_female: {
          filter: {term: {'respondent.gender': 'F'}},
          aggs: {female_count: {sum: {field: 'intabweight'}}},
        },
        Marriage_count: {
          filter: {range: {'household.numberofchildren': {gt: 0}}},
          aggs: {married_people: {sum: {field: 'dayaa.aalivesd'}}},
        },
        No_of_male: {
          filter: {term: {'respondent.gender': 'M'}},
          aggs: {male_count: {sum: {field: 'intabweight'}}},
        },
      },
    },
    UNIVERSE_MONTHLY: {
      date_histogram: {field: 'broadcastdate', interval: 'month', format: 'yyyy-MM'},
      aggs: {SUM_AVG_UE: {sum: {field: 'intabweight'}}},
    },
    UNIVERSE: {avg_bucket: {buckets_path: 'UNIVERSE_MONTHLY>SUM_AVG_UE'}},
    avg_income: {avg_bucket: {buckets_path: 'METRICS>Avg_income'}},
    home_owners: {avg_bucket: {buckets_path: 'METRICS>Home_owners>home_owners_count'}},
    no_of_children: {avg_bucket: {buckets_path: 'METRICS>No_of_children>children_count'}},
    no_of_female: {avg_bucket: {buckets_path: 'METRICS>No_of_female>female_count'}},
    no_of_male: {avg_bucket: {buckets_path: 'METRICS>No_of_male>male_count'}},
  }
}

export default metrics



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/metrics.js